import React, { useState } from "react";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  showError,
  showSuccess,
} from "../../../helpers/Notifications/Notification";
import { deleteLibrary } from "../../../slices/Admin/contolLibrary.slice";
import images from "../../../assets/images";
import {
  ConfirmDialog,
  IconButton,
  Table,
  TablePanel,
  useClientPagination,
} from "../../../components/ds";

const ControlLibraryTable = ({
  isAdminView,
  populateLibraryList,
  handleDrawerOpen,
  setDrawerVisible,
}) => {
  const { libraryList } = useSelector((state) => state.controlLibrary);
  const dispatch = useDispatch();
  const [pendingDelete, setPendingDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const rows = libraryList || [];
  const pager = useClientPagination(rows, 10);

  const handleLinkDelete = (link) => {
    setDeleting(true);
    dispatch(
      deleteLibrary(link.id, (status) => {
        setDeleting(false);
        if (status === "success") {
          showSuccess("Link deleted successfully");
          populateLibraryList();
          setDrawerVisible(false);
          setPendingDelete(null);
        } else {
          showError("Link could not be deleted");
        }
      })
    );
  };

  return (
    <div className="ops-page">
      <div className="table-title">Links</div>
      <ConfirmDialog
        open={Boolean(pendingDelete)}
        onClose={() => !deleting && setPendingDelete(null)}
        onConfirm={() => handleLinkDelete(pendingDelete)}
        title="Delete link?"
        confirmLabel="Delete"
        busy={deleting}
      >
        {pendingDelete ? (
          <p style={{ margin: 0 }}>
            Delete <strong>{pendingDelete.title}</strong>? This cannot be undone.
          </p>
        ) : null}
      </ConfirmDialog>

      <div className="list-table">
        <TablePanel
          title="Links"
          total={pager.total}
          from={pager.from}
          to={pager.to}
          page={pager.page}
          totalPages={pager.totalPages}
          pageSize={pager.pageSize}
          onPageChange={pager.setPage}
          onPageSizeChange={pager.setPageSize}
          empty="No links yet."
        >
          <Table className="ops-ds-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>URL</th>
                {isAdminView ? (
                  <th className="ops-actions" aria-label="Actions" />
                ) : null}
              </tr>
            </thead>
            <tbody>
              {pager.pageItems.map((link) => (
                <tr key={link.id}>
                  <td>{link.title}</td>
                  <td className="ops-soft-wrap">
                    <a
                      className="library-link"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {link.url}
                      <img
                        src={images.ExportIcon}
                        className="export-icon"
                        alt=""
                      />
                    </a>
                  </td>
                  {isAdminView ? (
                    <td className="ops-actions">
                      <div style={{ display: "inline-flex", gap: 2 }}>
                        <IconButton
                          label="Edit link"
                          onClick={() => handleDrawerOpen(link)}
                        >
                          <VisibilityOutlined />
                        </IconButton>
                        <IconButton
                          variant="destructive"
                          label="Delete link"
                          onClick={() => setPendingDelete(link)}
                        >
                          <CloseOutlined />
                        </IconButton>
                      </div>
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </Table>
        </TablePanel>
      </div>
    </div>
  );
};

export default ControlLibraryTable;
